<template>
    <div class="title">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'CardTitle'
};
</script>
